import { render, staticRenderFns } from "./DataDict.vue?vue&type=template&id=ca2b120a"
import script from "./DataDict.vue?vue&type=script&lang=js"
export * from "./DataDict.vue?vue&type=script&lang=js"
import style0 from "./DataDict.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports